import { gql as t } from "@apollo/client";
import { PublicAccountFragment as c, PublicInvitationFragment as i } from "../fragment/account.js";
const o = t`
  query GetPublicAccountDetail($input: getPublicAccountDetailInput!) {
    getPublicAccountDetail(input: $input) {
      account {
        ...PublicAccount
      }
      accountInvitation {
        ...PublicInvitation
      }
    }
  }

  ${c}
  ${i}
`;
export {
  o as default
};
//# sourceMappingURL=getPublicAccountDetail.js.map
